import { render, staticRenderFns } from "./WorkInProgress.vue?vue&type=template&id=98104a26&scoped=true&"
import script from "./WorkInProgress.vue?vue&type=script&lang=js&"
export * from "./WorkInProgress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98104a26",
  null
  
)

export default component.exports